import * as React from "react";
import { IStateProgressChartState } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/ProgressChart/IStateProgressChartState";
import { DrawChart } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/Helpers/Chart/DrawChart";
import { StateProgressChartContainer } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/Helpers/Chart/StateProgressChartContainer";
import { GetCountsDictionary } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/Helpers/Data/Dictionaries/GetCountsDictionary";
import { LoadDataAsync } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/Helpers/Data/LoadDataAsync";
import ChevronPanel from "source/app/presentation/Shared/ChevronPanel/ChevronPanel";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { GetDominanceDictionary } from "./Helpers/Data/Dictionaries/GetDominanceDictionary";
import { ERPGIcon } from "motw_core/UI/Icons/ERPGIcon";

export function StateProgressChart() {
    const [state, setState] = React.useState<IStateProgressChartState>({
        isOpen: false,
        dwkc_emotionCharacterCounts: undefined,
        countsDictionary: undefined,
        dominanceDictionary: undefined,
    });

    React.useEffect(() => {
        if (!state.isOpen) {
            return;
        }

        if (state.dwkc_emotionCharacterCounts === undefined) {
            let isCurrent = true;

            LoadDataAsync().then((emotionCharacterCounts) => {
                if (!isCurrent) {
                    return;
                }

                var countsDictionary = GetCountsDictionary(
                    emotionCharacterCounts
                );

                var dominanceDictionary =
                    GetDominanceDictionary(countsDictionary);

                setState((currentState) => ({
                    ...currentState,
                    dwkc_emotionCharacterCounts: emotionCharacterCounts,
                    countsDictionary,
                    dominanceDictionary,
                }));
            });

            return () => {
                isCurrent = false;
            };
        }
    }, [state.isOpen]);

    React.useEffect(() => DrawChart(state), [state]);

    return (
        <div>
            <ChevronPanel
                id="StateProgress_ChevronPanel"
                label="State Progress"
                icon={ERPGIcon["radial-balance"]}
                whenClicked={() =>
                    setState({ ...state, isOpen: !state.isOpen })
                }
                dynamicOpacity={false}
                withClasses={StyleClassAuto({
                    textAlign: `center`,
                    margin: `5px`,
                })}
            >
                <StateProgressChartContainer
                    {...{ data: state.dwkc_emotionCharacterCounts }}
                />
            </ChevronPanel>
        </div>
    );
}
